<template>

    <div class="press-page">
        <Header></Header>
        <section class="press-section">
            <div class="container">
                <div class="row row-2">
                    <div class="col-md-12">
                        <router-link to="/press" style="margin-bottom: 30px;display: inline-block;"> < Back to press</router-link>
                        <h3>{{list.title}}</h3>
                        <h4><span>By {{list.author}}</span> <span class="bullet"></span> <span>{{list.date | formatDate}}</span></h4>
                        <div class="press-featured-img background-fit" :style="{ backgroundImage: `url(${imageUrl+list.images[0].bgImageFile})` }">

                        </div>
                        <div v-html="list.message"></div>
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from './Header'
    import Footer from './Footer'
    import axios from 'axios'
    import router from '../router'
    import backgroundUrl from '@/assets/img/press/image1.jpg'

    export default {
        name: 'PressDetail',
        components: {
            'Header': Header,
            'Footer': Footer
        },
        data() {
            return {
                backgroundUrl: backgroundUrl,
                msg: 'Welcome to Your Vue.js App',
                pressId: router.history.current.params.id,
                imageUrl: process.env.imageUrl,
                list: ''
            }
        },
        mounted () {
            axios
                .get('/pressById', {
                    params: {
                        eventId: this.pressId
                    }
                })
                .then(response => {
                    this.list = response.data


                })
                .catch(error => console.log(error))
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/PressDetail.vue